  $('.specification-tab .material-option').click(function(){
  	$('.specification-tab .material-option').addClass('active');
  	$('.specification-tab .cell-size').removeClass('active');
    $('.specification-tab .drive-control').removeClass('active');
  	$('.specification-material-option').addClass('active');
  	$('.specification-drive-controller-option').removeClass('active');
  	$('.specification-cell-size-option').removeClass('active');
  });

    $('.specification-tab .cell-size').click(function(){
  	$('.specification-tab .material-option').removeClass('active');
  	$('.specification-tab .cell-size').addClass('active');
    $('.specification-tab .drive-control').removeClass('active');
  	$('.specification-material-option').removeClass('active');
  	$('.specification-drive-controller-option').removeClass('active');
  	$('.specification-cell-size-option').addClass('active');
  });
  
    $('.specification-tab .drive-control').click(function(){
  	$('.specification-tab .material-option').removeClass('active');
  	$('.specification-tab .cell-size').removeClass('active');
    $('.specification-tab .drive-control').addClass('active');
  	$('.specification-material-option').removeClass('active');
  	$('.specification-drive-controller-option').addClass('active');
  	$('.specification-cell-size-option').removeClass('active');
  });

  $('.icon-value-wrapper-1').children().addClass('active');
  $('.icon-detail-wrapper-1').addClass('active');
  $('.icon-table-wrapper-1').addClass('active');
  function driveControlFunction($trigger,$target,$target2) {	
	$($trigger).on('click', function(event){
      event.preventDefault();	
      $($trigger).children().addClass('active');
      $($trigger).siblings().children().removeClass('active');
      $($target).addClass('active');
      $($target).siblings().removeClass('active');
      $($target2).addClass('active');
      $($target2).siblings().removeClass('active');
 	});
}	
driveControlFunction('.icon-value-wrapper-1','.icon-detail-wrapper-1','.icon-table-wrapper-1');	
driveControlFunction('.icon-value-wrapper-2','.icon-detail-wrapper-2','.icon-table-wrapper-2');	
driveControlFunction('.icon-value-wrapper-3','.icon-detail-wrapper-3','.icon-table-wrapper-3');